<style lang="less" scoped>
    .btn-ct {
        text-align: center;
        color: #df9c3b;
        display: block;
        width: 1.06rem;
        height: 1.06rem;
        line-height: 1.06rem;
        font-size: .26rem;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -0.53rem;
        margin-left: -0.53rem;
        background: url("https://staticcdn-yy-prd.pydp888.com/award/kline/img/1.0/page_2.0_bg_ico.png?v=1.0.7") 50% 50% no-repeat;
        background-size: auto 100%;
    }
</style>

<template>
    <div v-if="isValidKid(kid)" class="play-foot">
        <div v-if="isPlayedKid(kid)" class="u-play-btns">
            <a class="play-btn left play-btn--prev" :class="{disabled: !canPrev}" href="javascript:;" @click="prev"><span>上一题</span></a>
            <a class="play-btn right play-btn--next" :class="{disabled: !canNext}" href="javascript:;" @click="next"><span>下一题</span></a>
        </div>
        <div v-else class="u-play-btns">
            <a class="play-btn left play-btn--up enabled" href="javascript:;" :class="{disabled: !canPlay}" @click="dlgShow" data-action="1" id="js-btn-action--rt"><span>猜涨</span></a>
            <a class="play-btn right play-btn--down enabled" href="javascript:;" :class="{disabled: !canPlay}" @click="dlgShow"><span>猜跌</span></a>
        </div>
        <!-- {{curOid}}:{{allCount}}
        prevKid: {{prevPlayKid}}
        nextKid: {{nextPlayKid}} -->
        <!-- <a class="btn-ct" href="javascript:;" x-click="dk.settingShowDlg" data-game-id="49348241" id="game-play__curStep">
            <span class="btn-ct__num">{{curOid}}/{{allCount}}</span>
        </a> -->
        <foot-button-center @click="clickCenter" />

        <dlg-play :cup-id="cupId" :game-id="gameId" :kid="kid" :today="today" :show="dlgDisplay" @submitted="submitted"
            @close="dlgClose" />
        <dlg-result v-if="dlgResult" @close="showResult(false)" />
    </div>
</template>

<script>
    import FootButtonCenter from './button-center'
    import DlgPlay from '../dlg/play'
    import DlgResult from '../dlg/result'
    import {
        mapGetters
    } from 'vuex'
    export default {
        name: 'play-foot',
        data() {
            return {
                dlgDisplay: false,
                dlgResult: false
            }
        },
        props: ['cupId', 'gameId', 'kid', 'today'],
        components: {
            [FootButtonCenter.name]: FootButtonCenter,
            [DlgPlay.name]: DlgPlay,
            [DlgResult.name]: DlgResult
        },
        computed: {
            ...mapGetters(['isBetween', 'finalEnd',
                'finalBegin'
            ]),
            ...mapGetters('reality', ['isValidKid', 'isPlayedKid', 'nextPlayKid', 'prevPlayKid', 'isFinished',
                'playedCount', 'allCount', 'curOid'
            ]),
            isPlayed() {
                return this.isPlayedKid(this.kid)
            },
            canPrev() {
                return this.prevPlayKid > 0
            },
            canNext() {
                const {nextPlayKid} = this
                return nextPlayKid > 0 && (this.isPlayedKid(nextPlayKid) || this.canPlay)
            },
            canPlay() {
                const {isBetween, finalBegin, finalEnd} = this
                return isBetween(finalBegin, finalEnd)
            }
        },
        methods: {
            // ...mapActions('reality', ['loadPlay']),
            dlgShow() {
                if(this.canPlay) {
                    this.dlgDisplay = true
                }
            },
            dlgClose() {
                this.dlgDisplay = false
            },

            showResult(show) {
                this.dlgResult = !!show
            },

            clickCenter() {
                if(this.isPlayed) {
                    this.showResult(true)
                }
            },

            submitted() {
                const {canNext, cupId, playedCount, allCount} = this
                if(!canNext) {
                    this.$router.replace({
                        name: "finish",
                        params: {
                            cupId
                        }
                    })
                } else {
                    this.$toast({
                        type: 'html',
                        message: `<dl style="padding:.5em 1em;"><dt style="font-size:1.25em;padding:0 0 .5em;">提交成功</dt><dd>已完成<span class="red">${playedCount}</span>局，剩余<span class="red">${allCount - playedCount}</span>局</dd></dl>`
                    });
                }
            },
            async jump(kid) {
                const {
                    cupId,
                    gameId
                } = this
                // await this.loadPlay({
                //     cupId,
                //     gameId,
                //     kid
                // })
                this.$router.replace({
                    name: 'play',
                    params: {
                        cupId,
                        gameId,
                        kid
                    }
                })
            },

            async prev() {
                if (this.canPrev) {
                    this.jump(this.prevPlayKid)
                } else {
                    this.$toast('已是第一题了')
                }
            },

            // 下一局
            async next() {
                if (this.canNext) {
                    this.jump(this.nextPlayKid)
                } else {
                    this.$toast('已是最后一题了')
                }
            }
        },
        created() {

        }
    };

</script>
